export default {
  harassment: {
    create: {
      ingress:
        'Her har du mulighed for at fortælle os mere om, hvad du har været vidne til eller oplevet hos {organizationTitle}. Vi er meget taknemmelige for din hjælp til at sikre vores arbejdsplads.',
      instructions:
        'Skriv din rapport i tekstfeltet nedenfor. Du bestemmer selv, om du vil inkludere din e-mailadresse i rapporten eller vil være  anonym. Uanset om du er anonym eller ej, er det muligt at vende tilbage og følge op på din sag efter indsendelse af anmeldelsen.',
      instructions1:
        'Du modtager en bekræftelse på, at anmeldelsen er sendt, et sags-id og adgangskode, som du kan bruge, uanset om du er anonym eller ej, til at vende tilbage og følge op på sagen igen senere.',
      instructions2:
        'Rapporter vil blive modtaget af udpegede administratorer hos {organizationTitle}. Ingen andre kan læse den rapport, du har sendt. Hvis du har indtastet en e-mailadresse, får du besked, når sagen ændrer status, og hvis der er spørgsmål fra organisationen til dig. Vi vil derefter behandle din identitet med fortrolighed, og vi afslører den ikke, medmindre det er nødvendigt for sagen.',
      instructionsHeader: 'Hvordan fungerer det?',
      options: {
        confirmNotToIncludeEmail:
          'Jeg forstår, at hvis jeg ikke inkluderer min e-mailadresse, giver jeg afkald på muligheden for at blive underrettet, når status for min sag ændres, og den modtagende organisation ikke ved, hvem jeg er.',
        includeEmail: 'Jeg vil inkludere min e-mailadresse'
      }
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'Når du har indsendt rapporten, vil du af sikkerhedsmæssige årsager ikke længere kunne læse eller foretage ændringer. Du kan dog vende tilbage senere og følge sagens status, se eventuelle opfølgende spørgsmål fra {organizationTitle} og selv anonymt udfylde yderligere information.',
        confirmDescriptionEmailIncluded:
          'Da du har valgt at inkludere din e-mail, kontakter vi {email}, når sagen åbnes, og hvis vi har spørgsmål til dig. Tjek venligst din rapport nedenfor, før du indsender den.',
        confirmDescriptionEmailNotIncluded:
          'Du har valgt ikke at inkludere en e-mailadresse i rapporten, så vi vil ikke kunne kontakte dig. Tjek nedenstående rapport, før du indsender den.',
        createDescription: 'Skriv din beskrivelse her:',
        placeholder: 'Jeg vil gerne rapportere...',
        reporterGuide: {
          question1: 'Hvad er problemet?',
          question2: 'Hvornår skete dette?',
          question3: 'Hvem var involveret?',
          question4: 'Hvor skete det?',
          question5: 'Har du inkluderet alle detaljer?',
          question6: 'Du kan tilføje et billede, hvis du ønsker det',
          title: 'Vejledning til at skrive en rapport'
        },
        responseDescriptionEmailIncluded:
          'Du vil modtage en e-mail, når sagen åbnes af en administrator.'
      }
    },
    title: 'Rapporter til {organizationTitle}'
  },
  whistleblower: {
    alerts: {
      notValidLink: ' Følg venligst et gyldigt link for at komme hertil.'
    },
    buttons: {
      back: 'gå tilbage',
      continue: 'Fortsæt',
      noOption: 'Nej',
      send: 'Send rapport',
      yesOption: 'Ja'
    },
    confirm: {
      title: {
        reportNotSent: 'Rapport IKKE sendt!'
      }
    },
    create: {
      email: {
        help:
          'Hvis du vælger at inkludere en e-mail med din rapport, vender vi tilbage til dig om statusopdateringer, eller hvis vi har spørgsmål. Det er frivilligt at tilføje en e-mailadresse.',
        label: 'E-mail:',
        placeholder: 'Indtast venligst din e-mail her'
      },
      ingress:
        'Her har du mulighed for at rapportere uredelighed, som du er bekendt med eller har mistanke om, er sket eller vil ske hos {organizationTitle}. Kanalen skal kun bruges til at rapportere om uredelighed i arbejdsrelaterede situationer og kun hvis du har grund til at formode, at dine oplysninger er sande.',
      instructions:
        'Først vælger du, hvordan du vil aflægge din rapport. Du kan også beslutte, om du vil inkludere din e-mailadresse i rapporten eller forblive anonym. Uanset om du er anonym eller ej, er det muligt at vende tilbage og følge op på din sag efter indsendelse af anmeldelsen.',
      instructions1:
        'Så modtager du en bekræftelse på, at anmeldelsen er sendt, et sags-id og et kodeord, som du kan bruge, uanset om du er anonym eller ej, til senere at vende tilbage og følge op på sagen. Selvom du vælger at indberette via fysisk møde eller telefonopkald, kan du også følge sagen op digitalt, hvis du ønsker det.',
      instructions2:
        'Rapporter vil blive modtaget af udpegede administratorer på {organizationTitle}. Ingen andre kan læse den rapport, du har sendt. Hvis du har indtastet en e-mailadresse, får du besked, når sagen ændrer status, og hvis der er spørgsmål fra organisationen til dig. Vi behandler derefter din identitet fortroligt og afslører den ikke, medmindre det er nødvendigt for sagen.',
      instructionsHeader: 'Hvordan virker det?',
      options: {
        confirmNotToIncludeEmail:
          'Jeg forstår, at jeg ved ikke at inkludere min e-mailadresse giver afkald på muligheden for at få besked, når status for min sag ændres, da den modtagende organisation ikke ved, hvem jeg er.',
        includeEmail: 'Jeg vil gerne inkludere min e-mailadresse'
      }
    },
    followup: {
      buttons: {
        submit: 'Hent sagen'
      },
      messages: {
        buttons: {
          send: {
            help:
              'Du kan sende en opfølgningsmeddelelse, som vil blive læst af repræsentanter for den modtagende organisation. Ingen andre kan læse din besked.',
            title: 'Send besked'
          }
        },
        messageSent: 'Tak for din besked!',
        placeholder: 'Skriv en besked her',
        reporter: 'Rapportør',
        title: 'Beskeder',
        writtenByAdmin: 'Admin'
      },
      status: {
        new: {
          description: 'Din rapport er modtaget og vil snart blive gennemgået.',
          title: 'Ny'
        },
        open: {
          description:
            'Din rapport er modtaget og er i øjeblikket ved at blive gennemgået. Kom venligst tilbage senere for yderligere opdateringer. Hvis du har angivet kontaktoplysninger, kontakter vi dig.',
          title: 'Åben'
        },
        solved: {
          description:
            'Din anmeldelse er blevet behandlet, og undersøgelsen er nu afsluttet. Hvis du har angivet kontaktoplysninger, vender vi tilbage med yderligere oplysninger.',
          title: 'Løst'
        }
      },
      statusLabel: 'Sagen har status:',
      title: 'Sag {caseName}'
    },
    followupLogin: {
      caseLabel: 'Sags-id:',
      passwordLabel: 'Adgangskode:',
      title: 'Følg op på sagen'
    },
    messages: {
      error: {
        failedToSendReport: 'Rapporten kunne ikke sendes',
        organizationNotFound:
          'Vi kunne ikke finde en organisation at sende din rapport til. Sørg for, at du har fulgt et gyldigt link for at komme hertil.',
        whistleblowerInfoNotFound:
          'Kunne ikke finde oplysninger til whistleblower-rapportering i denne organisation'
      }
    },
    received: {
      bottomWarning:
        'Bemærk! Dette er den eneste mulighed for dig til at se oplysningerne ovenfor, så gem dem nu!',
      caseLabel: 'Sags-id:',
      linkLabel: 'Link',
      passwordLabel: 'Adgangskode:',
      title: 'Rapport modtaget!',
      topWarning: 'Opbevar venligst oplysningerne nedenfor  sikkert!'
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'Efter du har indsendt rapporten, vil du af sikkerhedsmæssige årsager ikke længere kunne læse eller foretage ændringer. Du kan dog vende tilbage senere og følge sagens status, se eventuelle opfølgende spørgsmål fra {organizationTitle} og selv anonymt udfylde yderligere information.',
        confirmDescriptionEmailIncluded:
          'Da du har valgt at inkludere din e-mail, kontakter vi {email}, når sagen åbnes, og hvis vi har spørgsmål til dig. Tjek venligst din rapport nedenfor, før du indsender den.',
        confirmDescriptionEmailNotIncluded:
          'Du har valgt ikke at inkludere en e-mailadresse i rapporten, så vi vil ikke kunne kontakte dig. Tjek nedenstående rapport, før du indsender den.',
        createDescription:
          'Beskriv, hvad der er sket, og hvorfor du vil anmelde dette. Medtag ikke personlige oplysninger, medmindre det er relevant for sagen.',
        label: 'Jeg vil indberette digitalt via denne formular',
        placeholder: 'Jeg vil gerne rapportere...',
        reporterGuide: {
          question1: 'Hvad er din bekymring?',
          question2: 'Hvornår skete dette?',
          question3: 'Hvem var involveret?',
          question4: 'Hvor skete det?',
          question5: 'Har du inkluderet alle detaljer?',
          question6: 'Du kan tilføje et billede, hvis du vil',
          title: 'Vejledning til at skrive en rapport'
        },
        responseDescriptionEmailIncluded:
          'Du vil modtage en e-mail-meddelelse, når sagen åbnes af en af administratorerne. Dette vil ske inden for 7 dage. Efter sagens åbning afslutter vi undersøgelsen inden for 3 måneder.',
        responseDescriptionEmailNotIncluded:
          'Da du har valgt at anmelde anonymt, har du afvist at modtage en e-mail-meddelelse, når sagen er åbnet. Du får heller ikke besked om anden sagsaktivitet. Ved at bruge nedenstående detaljer er det stadig muligt for dig at vende tilbage og følge sagens status.',
        responseIngress:
          'Tak for din rapport! Vi behandler din sag hurtigst muligt.'
      },
      phoneCall: {
        confirmDescription:
          'På næste trin vil du blive præsenteret for et telefonnummer, du kan ringe til. Er du sikker på, at du vil fortsætte med at rapportere via et telefonopkald?',
        createDescription:
          'Du får mulighed for at indtaste din rapport som en talebesked.',
        label: 'Jeg ønsker at indsende rapporten via et telefonopkald',
        message:
          '=== Rapportøren vil ringe og efterlade rapporten som en talebesked. ===',
        responseDescription:
          'For at aflægge din rapport skal du ringe til følgende telefonnummer og lægge en talebesked:',
        responseInstructions1: 'Ring til telefonnummeret ovenfor',
        responseInstructions2: 'Aflæg din rapport så detaljeret som muligt',
        responseInstructions3:
          'Hvis du ønsker at blive underrettet om ændringer i sagsstatus eller ny korrespondance, så angiv din e-mailadresse eller telefonnummer i rapporten.',
        responseInstructions4:
          'Gem nedenstående oplysninger, så du kan gå tilbage og følge op her.',
        responseInstructionsHeader: 'Instruktioner',
        responseTitle: 'Rapport via telefonopkald',
        responseWarning:
          'Hvis du ikke har efterladt en talebesked inden for 7 dage, vil din sag automatisk blive lukket.'
      },
      physicalMeeting: {
        confirmDescription:
          'Vi kontakter dig på {email} vedrørende din anmodning om at rapportere via et fysisk møde. Vil du fortsætte?',
        createDescription:
          'Vi tilbyder dig muligheden for at aflægge din rapport i et fysisk møde. For at gøre det skal du indtaste en e-mailadresse, som vi vil bruge til at kontakte dig for at planlægge et møde.',
        label: 'Jeg ønsker at aflevere rapporten i et fysisk møde',
        message:
          '=== Rapportøren anmodede om et fysisk møde for at aflægge rapporten. ===',
        responseDescription:
          'Tak! Vi vender tilbage med et forslag til, hvornår vi kan holde et fysisk møde, hvor du lægger din beretning.  Sørg for at gemme følgende oplysninger. Det skal du bruge, hvis du efter mødet ønsker at følge op på din sag.',
        responseTitle: 'Mødeindkaldelse sendt'
      }
    },
    title: 'Rapportér uredelighed hos {organizationTitle}'
  }
}
